import React , { Component } from 'react';
import {injectIntl} from 'react-intl';

import * as GraphConstants from '../library';

import { dateUtil } from '../library';

import { convertToArray, convertMessage, addTimeSeries, getMessage } from '../utils';


class SeriesTableHeader extends Component {

    render() {
        const {enabled} = this.props;
        const {formatMessage,formatDate} = this.props.intl;
        // console.log("SERIES-TABLE-HEADER");
        // console.dir(this.props.config);
        var context = this.props.config.context;
        var paths = GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths;

        let thStyle = {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        }


        var headers = [];
        //console.dir(this.props.series);
        //style={this.props.colStyle}
        this.props.series.forEach(function( serie, serieIndex ) {
            serie.rows.forEach(function (row, rowIndex) {
                if (enabled[serieIndex+1]) {
                headers.push(<th style={thStyle} key={'head-' + rowIndex + '-' + serieIndex}
                                 title={getMessage(row.key, paths, serieIndex, this.props.intl)}>{getMessage(row.key, paths, serieIndex, this.props.intl)}</th>);
                }
                }.bind(this))

        }.bind(this));

        var date = this.props.date
        var ddDate;

        var dUtil=dateUtil[this.props.drillDown];

        if (dUtil && date)
            ddDate = formatDate(date, dUtil);
        else
            ddDate = formatMessage({id:"allYears"});


        return (
            <thead>
            <tr>
                <th >{ddDate}</th>
                {headers}
            </tr>
            </thead>
        )
    }
}

class SeriesTableBody extends Component {

    render() {
      const {enabled} = this.props;

        const {drillDown} = this.props;
        const {context} = this.props.config;


        let chartConf = GraphConstants.urlsConfiguration[context.kind].operations[context.operation];



        let drilldown = drillDown;

        if ( !chartConf.clickable && chartConf.dataDetails ) {

            drilldown = chartConf.maxDrillDown;
        }



        let formatNumber = true;
        //style={this.props.colStyle}
        var rows = [];
        this.props.series.forEach(function(row,i) {

                var cols = [];
                row.forEach(function (col, j) {
                    if (!enabled || (enabled && enabled[j])) {

                        var val = convertMessage(col, j, drilldown, this.props.intl, formatNumber);

                        cols.push(<td key={'col-' + j}>{val}</td>);
                    }
                }.bind(this))

                rows.push(<tr key={'row-' + i}>{cols}</tr>)

        }.bind(this));

        return (
            <tbody>
            {rows}
            </tbody>
        )
    }
}


class SeriesTable extends Component {
    constructor(props) {
        super(props);

        this.convertSeries=this.convertSeries.bind(this);
        //this.addTimeSeries=this.addTimeSeries.bind(this);
        this.convertSeriesMerged=this.convertSeriesMerged.bind(this);
        this.convertSeriesSplitted=this.convertSeriesSplitted.bind(this);
        //  this.convertToArray=this.convertToArray.bind(this);
    }



    convertSeriesSplitted(series) {
        //console.log("converSeries-SPITTED");
    }
    convertSeriesMerged(series) {
        var rows = [];

        // Nell'array delle colonne ci sono i valori delle ascisse
        // Collezione prima array delle colonne
        //  console.debug(series.length);
        //  console.dir(series);

        let times = series.length;



        if (series.length===1) {
            times=series[0].rows.length;
        }

        //console.log("Times: "+ times);

        for (var s=0; s<series.length; s++) {
            var numElems=series[s].cols.length;
            //console.log("Numero Elementi colonna ["+s+"]="+numElems);
            if (numElems>0) {

                for (var ii=0; ii<numElems; ii++) {
                    rows[ii]=[];
                    rows[ii][0]=series[s].cols[ii];
                }

                for (var j=0; j<numElems; j++) {
                    for (var i=0; i<times; i++) {

                        if (series[i].rows[0]) {
                            rows[j][i+1]=series[i].rows[0].values[j];
                        }
                    }
                }
            }
        }

        return rows;
    }

    convertSeries(series, splitted) {
        return (splitted?
                this.convertSeriesSplitted(series):
                this.convertSeriesMerged(series)
        );
    }



    // convertToArray(series, array) {
    //   let serie;
    //   let rows, cols;
    //   let values;
    //   let i, r, v, c;
    //   for (i=0;i<series.length;i++) {
    //     serie=series[i];
    //     cols = serie.cols;
    //     rows=serie.rows;
    //     for (r=0; r<rows.length; r++) {
    //       values = rows[r].values;
    //       for (v=0;v<values.length; v++) {
    //         array[v][r+i+1]=values[v];
    //       }
    //     }
    //   }
    // }

    // L'implementazione è ridondante e insufficiente: prevede possibilità di avere
    // più timeseries previste per le serie ma non le gestisce (al momento)
    // FIXME: gestione di più timeseries.
    // addTimeSeries(series) {
    //   let res=[];
    //   let s,c, cols;
    //   for (s=0;s<series.length;s++) {
    //     cols = series[s].cols;
    //     for (c=0;c<cols.length;c++) {
    //       res[c]=[];
    //       res[c][0]=cols[c];
    //     }
    //   }
    //   return res;
    // }


    render() {

        const {context} = this.props.config;

        let seriesAsArray = addTimeSeries(this.props.series);

        let paths = GraphConstants.urlsConfiguration[context.kind].operations[context.operation].paths;

        convertToArray(this.props.series, seriesAsArray);

        let num=seriesAsArray[0].length;

        let fullEnabled=[];
        let filled = 1;
        fullEnabled.push(true);
        if (paths[0] ) {
          filled++;
          fullEnabled.push(true)
        }
        if (paths[1] && (paths[0].merge && paths[1].merge) ) {
            filled++;
          fullEnabled.push(false);
        } else {
            fullEnabled.push(true);
            filled++;
        }

        for (let i=filled; i<num; i++) {
            fullEnabled.push(true);
        }

        // Calcolo la larghezza della colonna in ba se al numero di colonne
        let widthValue=100/(num+1)+"%";


        let colstyle = {
            width : widthValue
        }


        return (
            //className="table table-stripped table-bordered"
            <table id={this.props.id} className="table table-bordered table-striped table-hover" style={{tableLayout:'fixed'}}>

                <SeriesTableHeader key="table-header"
                                   config={this.props.config}
                                   date={this.props.date}
                                   series={this.props.series}
                                   enabled={fullEnabled}
                                   intl={this.props.intl}
                                   colStyle={colstyle}
                                   drillDown={this.props.drillDown}/>

                <SeriesTableBody key="table-body"
                                 config={this.props.config}
                                 colStyle={colstyle}
                                 enabled={fullEnabled}
                                 series={seriesAsArray}
                                 intl={this.props.intl}
                                 drillDown={this.props.drillDown}/>

            </table>
        )
    }
}

export default injectIntl(SeriesTable, {withRef:true});



// WEBPACK FOOTER //
// ./src/components/SeriesTable.js